export const BASE_URL="http://ec2-3-35-149-174.ap-northeast-2.compute.amazonaws.com:8000"

export const colorSet = {
  pink: "#FECCBE",
  blue: "#3D6387",
  white: "#FFFFFF",
};
